// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"723":"1a4b082b","920":"c83967dd"}[chunkId] + ".chunk.js";
};